import type { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import type {
  ActionSubjectIdType,
  ActionSubjectType,
} from '@trello/analytics-types';
import { Analytics } from '@trello/atlassian-analytics';
import { Button } from '@trello/nachos/button';

import styles from './WhatIsTrelloBanner.less';

// eslint-disable-next-line @trello/assets-alongside-implementation
import templateGalleryWhatIsTrelloSvg from 'resources/images/template-gallery-what-is-trello.svg';

export const WhatIsTrelloBanner: FunctionComponent<{
  isCategoryPage?: boolean;
}> = ({ isCategoryPage }) => {
  const sendAnalyticsUIEvent = ({
    actionSubject,
    actionSubjectId,
  }: {
    actionSubject: ActionSubjectType;
    actionSubjectId: ActionSubjectIdType;
  }) => {
    Analytics.sendUIEvent({
      action: 'clicked',
      actionSubject,
      actionSubjectId,
      source: 'templateGalleryScreen',
    });
  };
  return (
    <div
      className={classNames(styles.whatIsTrelloBanner, {
        [styles.last]: isCategoryPage,
      })}
    >
      <div className={styles.content}>
        <h2 className={styles.heading}>
          <FormattedMessage
            id="templates.templates.what-is-trello-header"
            defaultMessage="What's Trello?"
            description="The title of the banner section"
          />
        </h2>
        <p className={styles.description}>
          <FormattedMessage
            id="templates.templates.what-is-trello-text"
            defaultMessage="Trello lets you work more collaboratively and get more done. Trello’s boards, lists, and cards enable you to organize and prioritize your projects in a fun, flexible, and rewarding way."
            description="The description of what Trello is and its benefits"
          />
        </p>
        <a
          className={styles.buttonLink}
          href="/signup"
          onClick={() =>
            sendAnalyticsUIEvent({
              actionSubject: 'button',
              actionSubjectId: 'signUpButton',
            })
          }
        >
          <Button className={styles.signupButton} appearance="primary">
            <FormattedMessage
              id="templates.templates.sign-up"
              defaultMessage="Sign up - it's free!"
              description="The text of the sign up button"
            />
          </Button>
        </a>
        <a
          href="/"
          target="_blank"
          className={styles.learnMoreLink}
          onClick={() =>
            sendAnalyticsUIEvent({
              actionSubject: 'link',
              actionSubjectId: 'learnMoreLink',
            })
          }
        >
          <FormattedMessage
            id="templates.templates.learn-more"
            defaultMessage="Learn more"
            description="The link to learn more about Trello"
          />
        </a>
      </div>
      <img
        alt=""
        role="presentation"
        className={styles.boardimage}
        src={templateGalleryWhatIsTrelloSvg}
      />
    </div>
  );
};
